import {
  Box,
  Button,
  Stack,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Typography,
} from '@mui/material'
import ContactDetails from './ContactDetails'
import VisibleList from './VisibleList'
import * as React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { useStudyContext } from '../../../Contexts/Modules/StudyModule/SelectedStudyModule'
import { FileCopy } from '@mui/icons-material'
import CloneModal from './CloneModal'
import { useStudyUpdate } from '../../../APIs/Hooks/StudyHooks'
import { useUserContext } from '../../../Contexts/UserConfig'
import { statusObject, statusSteps } from './ConfigureSteps'
import { stackGap } from '../../../Constants&Theme/Spacing'
import EthicsProtocols from './EthicsProtocols'

function StudyInfo() {
  //separated to prevent render intensive Phases from having to rerender onChange
  const { study_id } = useParams()
  const { studyQuery, studyEdit } = useStudyContext()
  const { loginConfig } = useUserContext()
  const { mutate: updateStudy } = useStudyUpdate(study_id)
  const [openCloneModal, setOpenCloneModal] = useState(false)
  const [studyChange, setStudyChange] = useState<any>({})
  return (
    <Stack
      gap={stackGap.row}
      direction={'row'}
    >
      <Stack
        sx={{ flex: 2 }}
        gap={stackGap.col}
      >
        <TextField
          fullWidth
          label="Study Name"
          value={studyChange?.StudyName ?? studyEdit?.StudyName ?? ''}
          disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
          onChange={(e: any) =>
            setStudyChange((s: any) => {
              return { ...s, StudyName: e.target.value }
            })
          }
          onBlur={(e: any) => {
            if (studyQuery.data?.StudyName !== e.target.value) {
              updateStudy({ StudyName: e.target.value })
            }
          }}
        />
        <TextField
          fullWidth
          label="Cage Card Comments"
          value={
            studyChange?.StudyCardComments ?? studyEdit?.StudyCardComments ?? ''
          }
          disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
          onChange={(e: any) =>
            setStudyChange((s: any) => {
              return { ...s, StudyCardComments: e.target.value }
            })
          }
          onBlur={(e: any) => {
            if (studyQuery.data?.StudyCardComments !== e.target.value) {
              updateStudy({ StudyCardComments: e.target.value })
            }
          }}
        />
        <TextField
          fullWidth
          multiline
          minRows={6}
          label="Summary"
          value={studyChange?.StudySummary ?? studyEdit?.StudySummary ?? ''}
          disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
          onChange={(e: any) =>
            setStudyChange((s: any) => {
              return { ...s, StudySummary: e.target.value }
            })
          }
          onBlur={(e: any) => {
            if (studyQuery.data?.StudySummary !== e.target.value) {
              updateStudy({ StudySummary: e.target.value })
            }
          }}
          sx={{
            height: '100%',
            '& .MuiInputBase-root': {
              height: '100%',
            },
            '& .MuiInputBase-input': {
              height: '100% !important',
            },
          }}
        />
        <TextField
          fullWidth
          multiline
          minRows={6}
          label="Endpoints"
          value={studyChange?.StudyEndpoints ?? studyEdit?.StudyEndpoints ?? ''}
          disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
          onChange={(e: any) =>
            setStudyChange((s: any) => {
              return { ...s, StudyEndpoints: e.target.value }
            })
          }
          onBlur={(e: any) => {
            if (studyQuery.data?.StudyEndpoints !== e.target.value) {
              updateStudy({ StudyEndpoints: e.target.value })
            }
          }}
        />
        <Stack
          width={1}
          gap={stackGap.row}
          direction={'row'}
        >
          <ContactDetails
            updateStudy={updateStudy}
            contact={'Prm'}
          />
          <ContactDetails
            updateStudy={updateStudy}
            contact={'Sec'}
          />
        </Stack>
      </Stack>
      <Stack
        sx={{ flex: 1 }}
        gap={stackGap.col}
      >
        <Stepper
          activeStep={statusSteps.indexOf(
            studyQuery.data?.StudyStatus || 'PEN',
          )}
          alternativeLabel
        >
          {statusSteps.map((status, index) => {
            return (
              <Step key={index}>
                <StepLabel
                  optional={
                    <Typography variant="caption">
                      {statusObject[status].caption}
                    </Typography>
                  }
                >
                  {statusObject[status].label}
                </StepLabel>
              </Step>
            )
          })}
        </Stepper>
        <Box sx={{ justifyContent: 'center', display: 'flex' }}>
          <Button
            variant={'outlined'}
            disabled={
              !studyQuery.data ||
              studyQuery.data?.StudyStatus === 'ARC' ||
              !loginConfig?.Modules?.EditStudy ||
              study_id === '1'
            }
            color={
              (
                !studyQuery.data ||
                statusSteps.indexOf(studyQuery.data!.StudyStatus) === 0
              ) ?
                'success'
              : 'error'
            }
            onClick={() =>
              updateStudy({
                StudyStatus:
                  statusSteps.indexOf(studyQuery.data!.StudyStatus) === 0 ?
                    'ACT'
                  : 'ARC',
              })
            }
            size={'large'}
          >
            {statusSteps.indexOf(studyQuery.data?.StudyStatus || 'PEN') === 0 ?
              'Progress to Active'
            : 'Archive Study'}
          </Button>
        </Box>
        <EthicsProtocols />
        <CloneModal
          open={openCloneModal}
          setOpen={setOpenCloneModal}
        />
        <Box sx={{ justifyContent: 'center', display: 'flex' }}>
          <Button
            variant={'outlined'}
            disabled={!loginConfig?.Modules?.EditStudy || study_id === '1'}
            onClick={() => setOpenCloneModal(true)}
            startIcon={<FileCopy />}
            size={'large'}
          >
            {'Clone Study'}
          </Button>
        </Box>
        <VisibleList />
      </Stack>
    </Stack>
  )
}

export default StudyInfo
